import { Tooltip } from '@mui/material';
import InfoIcon from 'crono-fe-common/icons/Info-Icon';
import { colors } from 'crono-fe-common/theme';
import { EmailIntegrationType } from 'crono-fe-common/types/emailSettings';
import { EmailIconFromIntegration } from 'utils/fe-utils-tsx';
import { cn } from 'utils/style-utils';

interface SequenceAssignedMailboxCardProps {
  email: string;
  //Only known for mailboxes of the logged-in user, so absent on a sequence
  //owned by somebody else
  integration?: EmailIntegrationType;
}

const SequenceAssignedMailboxCard = ({
  email,
  integration,
}: SequenceAssignedMailboxCardProps) => {
  return (
    <div className="flex justify-center pl-16">
      <div className="flex items-center justify-between h-10 rounded-md max-w-max p-1 pr-3 gap-1.5 border border-neutral-300 bg-neutral-100">
        <div className="flex items-center">
          {integration && (
            <div
              className="flex items-center justify-center size-8"
              data-testid="mailbox-provider-icon"
            >
              <EmailIconFromIntegration integration={integration} />
            </div>
          )}

          <p className={cn('text-sm font-medium', { 'pl-2': !integration })}>
            {email}
          </p>
        </div>

        <Tooltip
          placement="top"
          arrow
          title="This email is assigned when the contact is enrolled in the sequence. You can change the sending email only from the Structure tab"
        >
          <div className="flex items-center justify-center cursor-pointer">
            <InfoIcon color={colors.grey11} />
          </div>
        </Tooltip>
      </div>
    </div>
  );
};

export default SequenceAssignedMailboxCard;
